import { Pipe } from '@angular/core';

@Pipe({
  name: 'remainingDays',
})
export class RemainingDaysPipe {
  transform(value: string): number {
    const targetDate = new Date(value);
    const currentDate = new Date();
    const timeDiff = targetDate.getTime() - currentDate.getTime();
    const days = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return days > 0 ? days : 0;
  }
}
